import React, { useEffect, useState } from "react";
import Shearchbar from "./Shearchbar";
import Security from "./Security";
import Footer from "./Footer";
import Navbar from "./Navbar";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import "react-toastify/dist/ReactToastify.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Manubar from "./Manubar";
import "react-tabs/style/react-tabs.css";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Stack,
  Paper,
  Menu,
  MenuItem,
  IconButton,
  Grid,
} from "@mui/material";
import {
  Person,
  ExitToApp,
  Article,
  PrivacyTip,
  Groups,
  MoreVert,
} from "@mui/icons-material";
import TransactionTable from "./TransactionTable";
import Orders from "./Orders";
import Address from "./Address";
import UserProfile from "./UserProfile";
import ChangePin from "./ChangePin";
import Dashboard from "./Dashboard";

const Myaccount = () => {
  let Navigate = useNavigate();
  const location = useLocation();
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  const [activeTab, setActiveTab] = useState(location.state || "dashboard");
  const [policy, setPolicy] = useState([]);
  const [terms_and_condition, setterms_and_condition] = useState([]);
  const [about_us, setabout_us] = useState([]);
  const [dashboardData, setDashboardData] = useState({
    totalCount: 0,
    pendingCount: 0,
    cancelledCount: 0,
    completedCount: 0,
    totalAmount: 0,
  });

  // Mobile menu state
  const [mobileMenuAnchor, setMobileMenuAnchor] = useState(null);

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const items = { user_id: _id };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          {
            headers: {
              token: token,
            },
          },
        );

        if (res.data.result) {
          setget_user_profile(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching profile", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  let Logout = () => {
    try {
      let item = {
        _id: _id,
      };
      axios
        .post(`${process.env.REACT_APP_API}website/logout`, item)
        .then((res) => {
          if (res.data.result) {
            localStorage.removeItem("ssstoken");
            secureLocalStorage.removeItem("n_id");
            secureLocalStorage.removeItem("n_token");
            secureLocalStorage.removeItem("n_mobile_no");
            secureLocalStorage.removeItem("n_otp");
            Navigate(`/`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {}
  };

  const fetchAbout = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/about_us`,
        {
          headers: { token },
        },
      );
      if (res.data?.result) {
        setabout_us(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching about us:", error);
    }
  };

  const fetchPolicy = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/privacy_policy`,
        {
          headers: { token },
        },
      );
      if (res.data?.result) {
        setPolicy(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching privacy policy:", error);
    }
  };

  const fetchTerms = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/terms_and_condition`,
        {
          headers: {
            token: token,
          },
        },
      );

      if (res.data?.data) {
        setterms_and_condition(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching terms and conditions:", error);
    }
  };

  const fetchDashboardData = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/dashboard`,
        { user_id: _id },
      );

      if (res.data?.data) {
        setDashboardData(res.data.data);
      }
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };

  useEffect(() => {
    if (activeTab === "dashboard") {
      console.log("Dashboard");
      fetchDashboardData();
    }

    if (activeTab === "orders") {
      console.log(activeTab);
    }

    if (activeTab === "transactions") {
      console.log(activeTab);
    }

    if (activeTab === "address") {
      console.log(activeTab);
    }

    if (activeTab === "aboutus") {
      console.log(activeTab);
      fetchAbout();
    }

    if (activeTab === "privacyPolicy") {
      console.log(activeTab);
      fetchPolicy();
    }

    if (activeTab === "termsandcondition") {
      console.log(activeTab);
      fetchTerms();
    }
  }, [activeTab]);

  // Mobile menu handlers
  const handleMobileMenuOpen = (event) => {
    setMobileMenuAnchor(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuAnchor(null);
  };

  const handleMobileMenuItemClick = (tab) => {
    setActiveTab(tab);
    handleMobileMenuClose();
  };

  return (
    <div>
      <div>
        <div className="modal fade offcanvas-modal" id="exampleModal">
          <div className="modal-dialog offcanvas-dialog">
            <div className="modal-content">
              <Manubar />
            </div>
          </div>
        </div>
        <header>
          <Shearchbar />
          <Navbar />
        </header>
        <nav className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    my account
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </nav>
        <div className="my-account section-mb">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-between align-items-center">
                  <h3 className="title text-capitalize mb-5 pb-4">
                    my account
                  </h3>

                  {/* Mobile Menu Button - Only visible on small screens */}
                  <div className="d-lg-none mb-5">
                    <IconButton
                      onClick={handleMobileMenuOpen}
                      sx={{
                        border: "1px solid #ddd",
                        borderRadius: "8px",
                        padding: "8px",
                      }}
                    >
                      <MoreVert />
                    </IconButton>

                    <Menu
                      anchorEl={mobileMenuAnchor}
                      open={Boolean(mobileMenuAnchor)}
                      onClose={handleMobileMenuClose}
                      PaperProps={{
                        style: {
                          width: "250px",
                          maxHeight: "400px",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => handleMobileMenuItemClick("dashboard")}
                      >
                        <i className="fa fa-tachometer me-2" /> Dashboard
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMobileMenuItemClick("orders")}
                      >
                        <i className="fa fa-cart-arrow-down me-2" /> Order
                        Status
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleMobileMenuItemClick("transactions")
                        }
                      >
                        <i className="fa fa-credit-card me-2" /> Transaction
                        History
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMobileMenuItemClick("address")}
                      >
                        <i className="fa fa-map-marker me-2" /> Address
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMobileMenuItemClick("profile")}
                      >
                        <i className="fa fa-user me-2" /> Profile
                      </MenuItem>
                      {/* <MenuItem
                        onClick={() => handleMobileMenuItemClick("changePin")}
                      >
                        <i className="fa fa-user me-2" /> Change Pin
                      </MenuItem> */}
                      <MenuItem
                        onClick={() =>
                          handleMobileMenuItemClick("privacyPolicy")
                        }
                      >
                        <i className="fa fa-user-secret me-2" /> Privacy Policy
                      </MenuItem>
                      <MenuItem
                        onClick={() =>
                          handleMobileMenuItemClick("termsandcondition")
                        }
                      >
                        <i className="fa fa-cogs me-2" /> Terms & Conditions
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleMobileMenuItemClick("aboutus")}
                      >
                        <i className="fa fa-info-circle me-2" /> About Us
                      </MenuItem>
                      <MenuItem onClick={Logout}>
                        <i className="fa fa-sign-out me-2" /> Logout
                      </MenuItem>
                    </Menu>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-12 mb-5 d-none d-lg-block">
                <div className="myaccount-tab-menu nav" role="tablist">
                  <Link
                    onClick={() => setActiveTab("dashboard")}
                    data-bs-toggle="tab"
                    className={`${activeTab === "dashboard" ? "active" : ""}`}
                    style={{
                      color: activeTab === "dashboard" ? "#fee894" : "black",
                    }}
                  >
                    <i className="fa fa-tachometer" /> Dashboard
                  </Link>
                  <Link
                    onClick={() => setActiveTab("orders")}
                    data-bs-toggle="tab"
                    className={`${activeTab === "orders" ? "active" : ""}`}
                    style={{
                      color: activeTab === "orders" ? "#fee894" : "black",
                    }}
                  >
                    <i className="fa fa-cart-arrow-down" /> Order Status
                  </Link>

                  <Link
                    onClick={() => setActiveTab("address")}
                    data-bs-toggle="tab"
                    className={`${activeTab === "address" ? "active" : ""}`}
                    style={{
                      color: activeTab === "address" ? "#fee894" : "black",
                    }}
                  >
                    <i className="fa fa-map-marker" /> Address
                  </Link>

                  <Link
                    onClick={() => setActiveTab("profile")}
                    data-bs-toggle="tab"
                    className={`${activeTab === "profile" ? "active" : ""}`}
                    style={{
                      color: activeTab === "profile" ? "#fee894" : "black",
                    }}
                  >
                    <i class="fa fa-user" aria-hidden="true"></i> Profile
                  </Link>

                  
                  <Link onClick={Logout}>
                    <i className="fa fa-sign-out" /> Logout
                  </Link>
                </div>
              </div>

              <div className="col-lg-9 col-12 mb-5">
                <div className="tab-content" id="myaccountContent">
                  {/* Your existing tab content remains the same */}
                  {activeTab === "dashboard" && <Dashboard />}

                  {activeTab === "orders" && <Orders />}

                  {activeTab === "transactions" && <TransactionTable />}

                  {activeTab === "address" && <Address />}

                  {activeTab === "privacyPolicy" && (
                    <Box sx={{ p: { xs: 2, sm: 3 } }}>
                      <Box sx={{ mb: 4 }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={2}
                          sx={{ mb: 2 }}
                        >
                          <PrivacyTip
                            sx={{
                              fontSize: { xs: 24, sm: 32 },
                              color: "primary.main",
                            }}
                          />
                          <Typography
                            variant="h4"
                            component="h3"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "1.5rem", sm: "2.125rem" },
                            }}
                          >
                            Privacy Policy
                          </Typography>
                        </Stack>
                      </Box>

                      <Paper
                        elevation={1}
                        sx={{
                          p: { xs: 3, sm: 4 },
                          borderRadius: 3,
                          background:
                            "linear-gradient(145deg, #f5f7fa 0%, #ffffff 100%)",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            lineHeight: 1.8,
                            textAlign: "justify",
                            color: "text.primary",
                            fontSize: { xs: "0.9rem", sm: "1.05rem" },
                          }}
                        >
                          {policy[0]?.description ||
                            "No privacy policy available at the moment."}
                        </Typography>
                      </Paper>
                    </Box>
                  )}

                  {activeTab === "aboutus" && (
                    <Box sx={{ p: { xs: 2, sm: 3 } }}>
                      <Box sx={{ mb: 4 }}>
                        <Stack
                          direction="row"
                          alignItems="center"
                          spacing={2}
                          sx={{ mb: 2 }}
                        >
                          <Groups
                            sx={{
                              fontSize: { xs: 24, sm: 32 },
                              color: "primary.main",
                            }}
                          />
                          <Typography
                            variant="h4"
                            component="h3"
                            sx={{
                              fontWeight: 600,
                              fontSize: { xs: "1.5rem", sm: "2.125rem" },
                            }}
                          >
                            About Us
                          </Typography>
                        </Stack>
                      </Box>

                      <Paper
                        elevation={1}
                        sx={{
                          p: { xs: 3, sm: 4 },
                          borderRadius: 3,
                          background:
                            "linear-gradient(145deg, #f5f7fa 0%, #ffffff 100%)",
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            lineHeight: 1.8,
                            textAlign: "justify",
                            color: "text.primary",
                            fontSize: { xs: "0.9rem", sm: "1.05rem" },
                          }}
                        >
                          {about_us[0]?.description ||
                            "No information available about us at the moment."}
                        </Typography>
                      </Paper>
                    </Box>
                  )}

                  {activeTab === "profile" && <UserProfile />}

                  {activeTab === "changePin" && <ChangePin />}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Security />
        <Footer />
      </div>
    </div>
  );
};

export default Myaccount;
